import classNames from 'classnames';
import { forwardRef } from 'react';
import type { CSSProperties, ReactNode } from 'react';

const getBorderColor = (isOver: boolean, hasError: boolean) => {
  if (hasError) {
    return 'border-red-500';
  }
  return isOver ? 'border-green-400' : 'border-transparent';
};

interface Props {
  isOver: boolean;
  hasError: boolean;
  children: ReactNode;
  fullWidth: boolean;
  style?: CSSProperties;
}

const DropzoneWrapper = forwardRef<HTMLDivElement, Props>(
  (
    {
      isOver,
      hasError,
      children,
      fullWidth,
      style,
      ...otherReactDropzoneProps
    }: Props,
    ref,
  ) => (
    <div
      className={classNames(
        isOver ? 'border-solid' : 'border-dashed',
        'rounded border-2 border-solid border-gray-200',
        getBorderColor(isOver, hasError),
        fullWidth ? 'w-full' : 'max-w-96',
        'h-56',
        'flex items-center justify-center',
        isOver && 'bg-gray-100',
      )}
      ref={ref}
      style={style}
      {...otherReactDropzoneProps}
    >
      {children}
    </div>
  ),
);

export default DropzoneWrapper;
